import React from 'react';
import style from './style.css';
import {Link} from 'found';
import {Grid} from 'react-flexbox-grid';


export default class Layout extends React.Component {

  render() {
    return <div className={style.layout}>
      <header className={style.header}>
        <Grid>
          <Link to="/" className={style.headerLink}>Mangabey - HIVDB data entry program</Link>
        </Grid>
      </header>
      <nav className={style.navbar}>
        <Grid>
          <ul className={style.navbarList}>
            <li>
              <a href="/" className={style.navbarLink}>Home</a>
            </li>
            <li>
              <a target="_blank" rel="noreferrer" href="https://drive.google.com/file/d/1EYmoeSa_5qj6ySz-R9Ka4NeBCELL5I3J/view?usp=sharing" className={style.navbarLink}>Manual</a>
            </li>
          </ul>
        </Grid>
      </nav>
      {/* <Grid className={style.gtip}>
        This program will save your work in your Google Drive Mangabey folder, it will ask you to grant access when needed.
      </Grid> */}
      <Grid className={style.container}>
        {this.props.children}
      </Grid>
    </div>;

  }

}



// WEBPACK FOOTER //
// ./src/views/layout/index.js